import React from 'react';
import styles from './Footer.module.scss';
import config from '../../../config/SiteConfig';

const Footer = () => (
  <footer className={styles.footer}>
    Footer goes here.
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx